export enum WIDGET_MICRO_APP {
    /**
     * @value Select a micro-app in settings to configure the widget.
     * @description Gives the instructions to configure the widget to the user.
     */
    CONFIGURATION_INSTRUCTIONS = 'WIDGET_MICRO_APP.CONFIGURATION_INSTRUCTIONS',
    /**
     * @value Micro-app header
     * @description Sub-section containing all options to display in a micro-app widget's header.
     */
    MICRO_APP_HEADER = 'WIDGET_MICRO_APP.MICRO_APP_HEADER',
    /**
     * @value Micro-app selection
     * @description Section title in a widget settings, indicating that user can select a widget of type "micro-app" in this section.
     */
    MICRO_APP_SELECTION = 'WIDGET_MICRO_APP.MICRO_APP_SELECTION',
    /**
     * @value No micro-app yet
     * @description Indicates to the user that no micro-app has been selected yet
     */
    NO_MICRO_APP_YET = 'WIDGET_MICRO_APP.NO_MICRO_APP_YET',
    /**
     * @value Refresh button
     * @description Option's title that displays a button into a micro-app widget header to refresh the current widget when selected.
     */
    REFRESH_BUTTON = 'WIDGET_MICRO_APP.REFRESH_BUTTON',
    /**
     * @value Select one micro-app amongst those installed.
     * @description Indicates the user what to do with this widget in order to get it working.
     */
    SELECTION_INSTRUCTIONS = 'WIDGET_MICRO_APP.SELECTION_INSTRUCTIONS',
    /**
     * @value Widget not configured
     * @description Informs the user that a widget has not been configured yet.
     */
    WIDGET_NOT_CONFIGURED = 'WIDGET_MICRO_APP.WIDGET_NOT_CONFIGURED',
}
